import React, { useContext } from 'react';

import { UsersContext } from "../../hooks/wrappers/UsersWrapper";

import BookingCalendar from "./bookings/BookingCalendar";
import Loading from "../shared/wait/Loading";


const Bookings = () => {
  const { isLoading: isLoadingUsers } = useContext(UsersContext)

  if(isLoadingUsers)
    return <Loading text="Cargando usuarios..."/>

  return <BookingCalendar />;
}

export default Bookings;
